/**
 * Order withdrawal front-end flow (vanilla JS, no framework dependency).
 * Works on both block and classic themes. Talks to the plugin REST API.
 */
import '../scss/front.scss';

( function () {
	'use strict';

	var cfg = window.hoyryOW || {};
	var t = cfg.i18n || {};

	function h( tag, props, children ) {
		var node = document.createElement( tag );
		props = props || {};
		Object.keys( props ).forEach( function ( key ) {
			if ( key === 'class' ) {
				node.className = props[ key ];
			} else if ( key === 'text' ) {
				node.textContent = props[ key ];
			} else if ( key === 'html' ) {
				node.innerHTML = props[ key ];
			} else if ( key.indexOf( 'on' ) === 0 && typeof props[ key ] === 'function' ) {
				node.addEventListener( key.slice( 2 ).toLowerCase(), props[ key ] );
			} else {
				node.setAttribute( key, props[ key ] );
			}
		} );
		( children || [] ).forEach( function ( child ) {
			if ( child ) {
				node.appendChild( typeof child === 'string' ? document.createTextNode( child ) : child );
			}
		} );
		return node;
	}

	function blockButton( props, variant ) {
		var btnProps = Object.assign( {}, props || {} );
		var wrapperClass = 'wp-block-button';

		if ( variant === 'secondary' ) {
			wrapperClass += ' is-style-outline';
		}

		btnProps.class = 'wp-block-button__link wp-element-button' + ( btnProps.class ? ' ' + btnProps.class : '' );

		return h( 'div', { class: wrapperClass }, [ h( 'button', btnProps ) ] );
	}

	function request( path, method, body ) {
		var opts = {
			method: method,
			credentials: 'same-origin',
			headers: { 'X-WP-Nonce': cfg.nonce || '' },
		};
		if ( body ) {
			opts.headers[ 'Content-Type' ] = 'application/json';
			opts.body = JSON.stringify( body );
		}
		return fetch( cfg.restUrl + path, opts ).then( function ( res ) {
			return res.json().catch( function () { return {}; } ).then( function ( data ) {
				return { status: res.status, data: data };
			} );
		} );
	}

	function App( root ) {
		this.root = root;
		this.app = root.querySelector( '.hoyry-ow__app' );
		this.messages = root.querySelector( '.hoyry-ow__messages' );
		this.prefillOrder = parseInt( root.getAttribute( 'data-prefill-order' ), 10 ) || 0;
		this.state = { order: null, email: '', name: '' };

		if ( ! this.app ) {
			return;
		}
	}

	App.prototype.message = function ( text, type ) {
		if ( ! this.messages ) {
			return;
		}
		this.messages.innerHTML = '';
		if ( text ) {
			this.messages.appendChild( h( 'div', { class: 'hoyry-ow__notice hoyry-ow__notice--' + ( type || 'info' ), text: text } ) );
		}
	};

	App.prototype.clear = function () {
		if ( ! this.app ) {
			return;
		}
		this.app.innerHTML = '';
	};

	App.prototype.renderLoggedInIntro = function () {
		if ( ! cfg.loggedIn || ! t.loggedInIntro ) {
			return null;
		}

		return h( 'div', { class: 'hoyry-ow__intro' }, [
			h( 'h2', { text: t.loggedInTitle || t.lookupTitle } ),
			h( 'p', { text: t.loggedInIntro } ),
		] );
	};

	App.prototype.orderListLabel = function ( order ) {
		var count = ( order.items || [] ).length;
		var parts = [ '#' + order.number ];

		if ( order.date ) {
			parts.push( order.date );
		}

		if ( count > 0 ) {
			var productWord = count === 1 ? t.productSingular : t.productPlural;
			if ( productWord ) {
				parts.push( count + ' ' + productWord );
			}
		}

		return parts.join( ' · ' );
	};

	App.prototype.renderOrderLink = function ( order ) {
		var self = this;
		var count = ( order.items || [] ).length;
		var productWord = count === 1 ? t.productSingular : t.productPlural;
		var main = h( 'span', { class: 'hoyry-ow__order-main' }, [
			h( 'span', { class: 'hoyry-ow__order-number', text: '#' + order.number } ),
		] );

		if ( order.date ) {
			main.appendChild( h( 'span', { class: 'hoyry-ow__order-date', text: order.date } ) );
		}

		var children = [ main ];

		if ( count > 0 && productWord ) {
			children.push( h( 'span', { class: 'hoyry-ow__order-meta', text: count + ' ' + productWord } ) );
		}

		children.push( h( 'span', { class: 'hoyry-ow__order-chevron', 'aria-hidden': 'true' } ) );

		return h( 'button', {
			type: 'button',
			class: 'hoyry-ow__order-link',
			'aria-label': self.orderListLabel( order ),
			onClick: function () {
				self.state.order = order;
				self.renderItems();
			},
		}, children );
	};

	App.prototype.start = function () {
		if ( ! this.app ) {
			return;
		}

		if ( ! cfg.restUrl ) {
			this.message( t.errorGeneric || 'Configuration error.', 'error' );
			return;
		}

		if ( cfg.loggedIn ) {
			this.loadOrders();
		} else {
			this.renderLookup();
		}
	};

	App.prototype.loadOrders = function () {
		var self = this;
		self.clear();

		var loadingWrap = h( 'div', { class: 'hoyry-ow__logged-in' } );
		var intro = self.renderLoggedInIntro();
		if ( intro ) {
			loadingWrap.appendChild( intro );
		}
		loadingWrap.appendChild( h( 'p', { class: 'hoyry-ow__loading', text: t.loadingOrders || t.loading } ) );
		self.app.appendChild( loadingWrap );

		request( 'eligible-orders', 'GET' ).then( function ( res ) {
			var orders = ( res.data && res.data.orders ) || [];
			if ( self.prefillOrder ) {
				var match = orders.filter( function ( o ) { return o.id === self.prefillOrder; } )[ 0 ];
				if ( match ) {
					self.state.order = match;
					self.renderItems();
					return;
				}
			}
			self.renderOrderList( orders );
		} ).catch( function () {
			self.message( t.errorGeneric, 'error' );
		} );
	};

	App.prototype.renderOrderList = function ( orders ) {
		var self = this;
		self.clear();

		var wrap = h( 'div', { class: 'hoyry-ow__logged-in' } );
		var intro = self.renderLoggedInIntro();
		if ( intro ) {
			wrap.appendChild( intro );
		}

		if ( ! orders.length ) {
			wrap.appendChild( self.renderEmptyOrdersBox() );
			self.app.appendChild( wrap );
			return;
		}

		wrap.appendChild( h( 'h3', { class: 'hoyry-ow__section-title', text: t.chooseOrder } ) );
		var list = h( 'ul', { class: 'hoyry-ow__orders' } );
		orders.forEach( function ( order ) {
			list.appendChild( h( 'li', {}, [ self.renderOrderLink( order ) ] ) );
		} );
		wrap.appendChild( list );
		self.app.appendChild( wrap );
	};

	App.prototype.renderEmptyOrdersBox = function () {
		var box = h( 'div', { class: 'hoyry-ow__empty' }, [
			h( 'h3', { class: 'hoyry-ow__section-title', text: t.noOrdersTitle } ),
			h( 'p', { text: t.noOrdersBody } ),
		] );

		if ( cfg.accountOrdersUrl ) {
			box.appendChild(
				h( 'p', {}, [
					h( 'a', {
						href: cfg.accountOrdersUrl,
						class: 'hoyry-ow__account-link',
						text: t.viewOrders,
					} ),
				] )
			);
		}

		return box;
	};

	App.prototype.renderLookup = function () {
		var self = this;
		self.clear();

		var orderInput = h( 'input', { type: 'text', id: 'hoyry-ow-order', class: 'hoyry-ow__input', value: self.prefillOrder ? String( self.prefillOrder ) : '' } );
		var emailInput = h( 'input', { type: 'email', id: 'hoyry-ow-email', class: 'hoyry-ow__input' } );

		var form = h( 'form', { class: 'hoyry-ow__form', onSubmit: function ( e ) {
			e.preventDefault();
			var ref = orderInput.value.trim();
			var email = emailInput.value.trim();
			if ( ! ref || ! email ) {
				self.message( t.required, 'error' );
				return;
			}
			self.message( t.loading );
			request( 'lookup', 'POST', { order: ref, email: email } ).then( function ( res ) {
				if ( res.status === 429 ) {
					self.message( t.tooManyAttempts, 'error' );
					return;
				}
				if ( res.data && res.data.found && res.data.order ) {
					self.message( '' );
					self.state.order = res.data.order;
					self.state.email = email;
					self.renderItems();
				} else {
					self.message( t.lookupFailed, 'info' );
				}
			} ).catch( function () {
				self.message( t.errorGeneric, 'error' );
			} );
		} } );

		form.appendChild( h( 'h2', { text: t.lookupTitle } ) );
		form.appendChild( h( 'p', { text: t.lookupIntro } ) );
		form.appendChild( h( 'p', {}, [ h( 'label', { for: 'hoyry-ow-order', text: t.orderNumberLabel } ), orderInput ] ) );
		form.appendChild( h( 'p', {}, [ h( 'label', { for: 'hoyry-ow-email', text: t.emailLabel } ), emailInput ] ) );
		form.appendChild( blockButton( { type: 'submit', class: 'hoyry-ow__btn hoyry-ow__btn--primary', text: t.lookupSubmit }, 'primary' ) );

		self.app.appendChild( form );
	};

	App.prototype.renderItems = function () {
		var self = this;
		self.clear();
		self.message( '' );

		var order = self.state.order;
		var qtyInputs = {};

		var form = h( 'form', { class: 'hoyry-ow__form' } );
		form.appendChild( h( 'h2', { text: t.selectItemsTitle } ) );
		form.appendChild( h( 'p', { text: t.orderLabel + ': #' + order.number } ) );

		( order.items || [] ).forEach( function ( item ) {
			var input = h( 'input', {
				type: 'number',
				min: '0',
				max: String( item.remaining ),
				step: '1',
				value: String( item.remaining ),
				class: 'hoyry-ow__qty',
				id: 'hoyry-ow-item-' + item.item_id,
			} );
			qtyInputs[ item.item_id ] = input;

			var row = h( 'div', { class: 'hoyry-ow__item' }, [
				h( 'label', { for: 'hoyry-ow-item-' + item.item_id, text: item.name } ),
				h( 'span', { class: 'hoyry-ow__qty-wrap' }, [
					h( 'span', { text: t.quantityLabel + ': ' } ),
					input,
					h( 'span', { class: 'hoyry-ow__max', text: ' / ' + item.remaining } ),
				] ),
			] );
			form.appendChild( row );
		} );

		var nameInput = h( 'input', { type: 'text', id: 'hoyry-ow-name', class: 'hoyry-ow__input', value: self.state.name || '' } );
		form.appendChild( h( 'p', {}, [ h( 'label', { for: 'hoyry-ow-name', text: t.nameLabel } ), nameInput ] ) );

		var messageInput = h( 'textarea', { id: 'hoyry-ow-message', class: 'hoyry-ow__input hoyry-ow__textarea', rows: '4' } );
		messageInput.value = self.state.message || '';
		form.appendChild( h( 'p', {}, [ h( 'label', { for: 'hoyry-ow-message', text: t.messageLabel } ), messageInput ] ) );

		form.appendChild( h( 'p', { class: 'hoyry-ow__delivery' }, [
			h( 'strong', { text: t.deliveryLabel + ': ' } ),
			h( 'span', { text: t.deliveryEmail } ),
		] ) );
		form.appendChild( h( 'p', { class: 'hoyry-ow__note', text: t.recipientNote } ) );

		var actions = h( 'div', { class: 'hoyry-ow__actions' } );
		if ( ! cfg.loggedIn ) {
			actions.appendChild( blockButton( { type: 'button', class: 'hoyry-ow__btn', text: t.back, onClick: function () { self.renderLookup(); } }, 'secondary' ) );
		} else {
			actions.appendChild( blockButton( { type: 'button', class: 'hoyry-ow__btn', text: t.back, onClick: function () { self.loadOrders(); } }, 'secondary' ) );
		}
		actions.appendChild( blockButton( { type: 'submit', class: 'hoyry-ow__btn hoyry-ow__btn--primary', text: t.continue }, 'primary' ) );
		form.appendChild( actions );

		form.addEventListener( 'submit', function ( e ) {
			e.preventDefault();
			var name = nameInput.value.trim();
			var selections = [];
			Object.keys( qtyInputs ).forEach( function ( id ) {
				var qty = parseInt( qtyInputs[ id ].value, 10 ) || 0;
				if ( qty > 0 ) {
					selections.push( { item_id: parseInt( id, 10 ), qty: qty } );
				}
			} );

			if ( ! name ) {
				self.message( t.required, 'error' );
				return;
			}
			if ( ! selections.length ) {
				self.message( t.selectOne, 'error' );
				return;
			}

			self.state.name = name;
			self.state.message = messageInput.value.trim();
			self.state.selections = selections;
			self.renderConfirm();
		} );

		self.app.appendChild( form );
	};

	App.prototype.renderConfirm = function () {
		var self = this;
		self.clear();
		self.message( '' );

		var order = self.state.order;
		var byId = {};
		( order.items || [] ).forEach( function ( i ) { byId[ i.item_id ] = i; } );

		self.app.appendChild( h( 'h2', { text: t.confirmTitle } ) );
		self.app.appendChild( h( 'p', { text: t.confirmIntro } ) );
		self.app.appendChild( h( 'p', { text: t.orderLabel + ': #' + order.number } ) );

		var list = h( 'ul', { class: 'hoyry-ow__summary' } );
		self.state.selections.forEach( function ( sel ) {
			var item = byId[ sel.item_id ];
			list.appendChild( h( 'li', { text: ( item ? item.name : '#' + sel.item_id ) + ' × ' + sel.qty } ) );
		} );
		self.app.appendChild( list );
		self.app.appendChild( h( 'p', {}, [ h( 'strong', { text: t.nameLabel + ': ' } ), h( 'span', { text: self.state.name } ) ] ) );

		if ( self.state.message ) {
			self.app.appendChild( h( 'p', {}, [ h( 'strong', { text: t.messageLabel + ': ' } ), h( 'span', { text: self.state.message } ) ] ) );
		}

		var actions = h( 'div', { class: 'hoyry-ow__actions' } );
		var sendBtn = blockButton( { type: 'button', class: 'hoyry-ow__btn hoyry-ow__btn--primary', text: t.confirmSend }, 'primary' ).querySelector( 'button' );
		actions.appendChild( blockButton( { type: 'button', class: 'hoyry-ow__btn', text: t.back, onClick: function () { self.renderItems(); } }, 'secondary' ) );
		actions.appendChild( sendBtn.parentElement );
		self.app.appendChild( actions );

		sendBtn.addEventListener( 'click', function () {
			sendBtn.disabled = true;
			sendBtn.textContent = t.sending;
			request( 'submit', 'POST', {
				order: order.id,
				email: self.state.email,
				name: self.state.name,
				message: self.state.message || '',
				items: self.state.selections,
			} ).then( function ( res ) {
				if ( res.status === 429 ) {
					self.message( t.tooManyAttempts, 'error' );
					sendBtn.disabled = false;
					sendBtn.textContent = t.confirmSend;
					return;
				}
				if ( res.data && res.data.success ) {
					self.renderSuccess();
				} else {
					self.message( ( res.data && res.data.message ) || t.errorGeneric, 'error' );
					sendBtn.disabled = false;
					sendBtn.textContent = t.confirmSend;
				}
			} ).catch( function () {
				self.message( t.errorGeneric, 'error' );
				sendBtn.disabled = false;
				sendBtn.textContent = t.confirmSend;
			} );
		} );
	};

	App.prototype.renderSuccess = function () {
		this.clear();
		this.message( '' );
		this.app.appendChild( h( 'div', { class: 'hoyry-ow__success' }, [
			h( 'h2', { text: t.successTitle } ),
			h( 'p', { text: t.successBody } ),
		] ) );
	};

	function init() {
		var roots = document.querySelectorAll( '.hoyry-ow' );
		Array.prototype.forEach.call( roots, function ( root ) {
			if ( root.getAttribute( 'data-ow-init' ) ) {
				return;
			}
			root.setAttribute( 'data-ow-init', '1' );
			var app = new App( root );
			if ( app.app ) {
				app.start();
			}
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
